import { msalInstance } from 'src/config/msalConfig'
import { loginPathForCurrentEnv } from 'src/config/environments'

export const handleLogout = async () => {
  try {
    // Get the current account before logout

    // Logout from Azure AD (avoids account picker issue). Preserve the selected
    // environment (?env=) so re-login stays on the same environment instead of
    // falling back to production. The env lives in the URL, so clearing
    // localStorage below does not lose it.
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + loginPathForCurrentEnv(),
      onRedirectNavigate: (url) => {
        // Clear localStorage and MSAL cache after successful logout
        localStorage.clear()
        sessionStorage.clear()

        return false
      },
    })

    // Clear MSAL cache completely
    await msalInstance.clearCache()
  } catch (error) {
    console.error('Logout error:', error)
    // Clear localStorage even if logout fails to ensure clean state
    localStorage.clear()
  }
}
